import { useMemo } from 'react';
import { useMyOrganizationsQuery } from '@upright/ui/api/iam/organizations/hooks';
import { useUnifiedShell } from '../unified-shell/use-unified-shell';
import { useUnifiedShellAudience } from '../unified-shell/use-unified-shell-audience';
import { selectableHomeOrganizations } from './selectable-home-organizations';

/** Shared by the selection resolver and menu, so neither can exclude the other's selection. */
export function useSelectableHomeOrganizations() {
  const query = useMyOrganizationsQuery();
  const shell = useUnifiedShell();
  const audience = useUnifiedShellAudience();
  const companyShell = shell.enabled && audience === 'company';
  return useMemo(
    () => selectableHomeOrganizations(query.data?.organizations, companyShell),
    [query.data?.organizations, companyShell],
  );
}
